import { DATE_FORMATS, type DateInput, formatWithPattern, getUserTimezone } from '@repo/common';

export function getNumberOfTheMonthLabel(date: DateInput): string {
  return formatWithPattern(date, DATE_FORMATS.DAY_NUMBER, getUserTimezone());
}

export const getPeriodLabel = (date: DateInput, periodType: 'week' | 'month' | 'year'): string => {
  switch (periodType) {
    case 'year':
      return formatWithPattern(date, DATE_FORMATS.YEAR_ONLY, getUserTimezone()); // E.g., "2024"
    case 'month':
    case 'week':
      return formatWithPattern(date, DATE_FORMATS.MONTH_YEAR, getUserTimezone()); // E.g., "October 2024"
    default:
      throw new Error('Invalid period type');
  }
};

// New functions for more specific month-based formatting
export function getMonthLabel(date: DateInput): string {
  return formatWithPattern(date, DATE_FORMATS.MONTH_ABBREV, getUserTimezone()); // E.g., "Oct"
}

export function getMonthKey(date: DateInput): string {
  return formatWithPattern(date, DATE_FORMATS.YEAR_MONTH, getUserTimezone()); // E.g., "2024-10"
}
